<template>
  <div class="lv-question-state">
    <DotLoading v-if="isLoading" />
    <div v-if="!isLoading && !_isTempQuesEmpty">
      <div class="mb-20 lv-question-state__title-wrap">
        <WsText001 h3 bold>
          {{ $t('關聯題目') }}
        </WsText001>
        <div v-if="editQues.hasBindTempQues == 1" class="lv-question-state__title-btn">
          <WsButton001 red mediumButton class="mr-20" @click="$_onInput(0, 'hasBindTempQues')">
            {{ $t('解除綁定') }}
          </WsButton001>
          <WsButton001 mediumButton @click="$_onFillFromTempQues()">
            {{ $t('自動填入') }}
          </WsButton001>
        </div>
        <WsButton001 v-else mediumButton @click="$_onInput(1, 'hasBindTempQues')">
          {{ $t('回復綁定') }}
        </WsButton001>
      </div>
      <LvQuestion :title="tempQues.title" :subTitle="tempQues.subTitle" class="mb-20">
        <template v-slot:content>
          <ListCard v-if="!isLoading" isTable bigTitle noPadding>
            <ListCardItem
              row
              isTable
              type="text"
              title="列入結果統計、不合規排行榜、今日點檢結論"
              :textContent="tempQues.isInStatsText"
            />
            <ListCardItem
              v-if="tempQues.quesType"
              row
              isTable
              type="text"
              title="題型"
              :textContent="tempQues.quesType.name"
            />
            <ListCardItem
              v-if="tempQues.quesType && tempQues.quesType.value === 'single-choice'"
              row
              isTable
              type="text"
              title="選項組合"
              :textContent="tempQues.option.name"
            />
            <ListCardItem
              v-if="tempQues.quesType && tempQues.quesType.value === 'single-choice'"
              row
              isTable
              type="slot"
              title="選項"
            >
              <template v-slot:slot>
                <LvInfoQuesOptionList :list="tempQues.optionList" />
              </template>
            </ListCardItem>
            <ListCardItem
              v-if="tempQues.quesType && tempQues.quesType.value === 'num'"
              row
              isTable
              type="text"
              title="條件設定方式"
              :textContent="tempQues.condition.name"
            />
            <ListCardItem
              v-if="
                tempQues.quesType &&
                tempQues.quesType.value === 'num' &&
                tempQues.condition &&
                tempQues.condition.type === 'custom-num'
              "
              row
              isTable
              type="slot"
              title="條件式"
            >
              <template v-slot:slot>
                <LvInfoQuesConditionList :list="tempQues.conditionList" />
              </template>
            </ListCardItem>
            <ListCardItem
              v-if="
                tempQues.quesType &&
                tempQues.quesType.value === 'num' &&
                tempQues.condition &&
                tempQues.condition.type === 'control-limit' &&
                !!tempQues.controlLimitData
              "
              row
              isTable
              type="text"
              title="Control Limit (管制界線)"
              :textContent="tempQues.controlLimitData"
            />
            <ListCardItem
              v-if="
                tempQues.quesType &&
                tempQues.quesType.value === 'num' &&
                tempQues.condition &&
                tempQues.condition.type === 'control-limit' &&
                !!tempQues.specLimitData
              "
              row
              isTable
              type="text"
              title="Spec Limit (合規界線)"
              :textContent="tempQues.specLimitData"
            />
            <ListCardItem
              v-if="tempQues.quesType && tempQues.quesType.value === 'num' && !!tempQues.unit"
              row
              isTable
              type="text"
              title="單位"
              :textContent="tempQues.unit"
            />
            <ListCardItem
              row
              isTable
              type="text"
              title="合規標準"
              titleIcon="icon-light"
              :textContent="tempQues.remark"
              :attaches="tempQues.tempAttaches"
            />
            <ListCardItem
              row
              isTable
              type="links"
              title="法規依據"
              titleIcon="icon-nav-law-outline"
              :links="tempQues.lawLinks"
              :textIconList="tempQues.effects"
              @click-law="$_onClickLaw($event)"
            />
          </ListCard>
        </template>
      </LvQuestion>
      <WsTextChip001
        thin
        gray
        fontSizeXs
        leadingIcon="icon-warning"
        textLabel="當關聯題目有更新版本時，您將會收到通知提醒，讓您可以參考公版題目來更新您的題目。若您不再需要參考此關聯題目，您可以解除綁定。"
        class="mb-20"
      />
      <WsTextChip001
        thin
        gray
        fontSizeXs
        leadingIcon="icon-warning"
        textLabel="若您需要完整引用建議題目內容，建議您點擊「自動填入」按鈕，以自動完整複製並貼上建議題目內容。"
        class="mb-20"
      />
    </div>
    <InputListCard v-if="!isLoading" :borderTop="!_isTempQuesEmpty">
      <WsText001 h3 bold class="mb-20">
        {{ $t('編輯') }}
      </WsText001>
      <WsTextChip001
        v-if="!_isTempQuesEmpty"
        thin
        gray
        fontSizeXs
        leadingIcon="icon-warning"
        textLabel="當您編輯完成此題目後，將影響過去、現在進行中、未來的點檢作業/草稿的點檢表題目及統計資料 ; 若您欲修改的題目內容差異很大，建議您新增一個題目。"
        class="mb-20"
      />
      <LvStateRadioBtn
        :value="editQues.keypoint"
        row
        required
        isNarrow
        title="重點關注"
        :radioButtonItem="focusRadioItems"
        class="mb-20"
        @input="$_onInput($event, 'keypoint')"
      />
      <WsInputTextareaButton001
        :value="editQues.title"
        required
        title="標題"
        rules="required"
        placeholder="輸入"
        :minHeight="134"
        class="mb-20"
        @input="$_onInput($event, 'title')"
      />
      <LvCheckbox
        v-if="
          editQues.quesType === 'single-choice' ||
          (editQues.quesType === 'num' && editQues.numConditionType !== 'num-only')
        "
        h4
        exclusive
        text="列入結果統計、不合規排行榜、今日點檢結論"
        justifyContent="start"
        :value="1"
        :select="editQues.isInStats"
        class="mb-20"
        @change="$_onInput($event, 'isInStats')"
      />
      <LvStateRadioBtn
        :value="editQues.quesType"
        row
        required
        isNarrow
        title="題型"
        rules="required"
        :radioButtonItem="_quesTypeRadioItems"
        class="mb-20"
        @input="$_onInput($event, 'quesType')"
      />
      <div v-if="editQues.quesType === 'single-choice'">
        <LvFlexBox justifyContent="start" class="mb-4">
          <LvText h6 bold>{{ $t('選項快速設定') }}</LvText>
        </LvFlexBox>
        <LvTextCard class="mb-20">
          <template v-slot:content>
            <div class="lv-question-state__btn-title-wrap mb-8">
              <LvText h6 bold>{{ $t('您可以點擊下列選項組合快捷鍵，快速建立選項！') }}</LvText>
              <WsTextButton001 primary noPadding @click="$_onOpenPopup('createChoicePopup')">{{
                $t('點此建立常用選項組合')
              }}</WsTextButton001>
            </div>
            <LvBtnList
              v-if="tempOptionList && tempOptionList.length > 0"
              white
              collapsable
              title="ESGoal系統建議常用選項組合："
              :aliceBlue="false"
              :btnList="tempOptionList"
              :isLoading="isLoadingTempOptionList"
              :borderBottom="commonChoiceGroup && commonChoiceGroup.length > 0"
              @click="$_onClickOptionSet($event, 'tempOption')"
            />
            <LvBtnList
              v-if="commonChoiceGroup && commonChoiceGroup.length > 0"
              white
              collapsable
              title="自訂常用選項組合："
              :aliceBlue="false"
              :btnList="commonChoiceGroup"
              :isLoading="isLoadingCommonChoiceGroup"
              @click="$_onClickOptionSet($event, 'commonChoice')"
            />
          </template>
        </LvTextCard>
        <LvFlexBox justifyContent="space-between" class="mb-4">
          <LvFlexBox justifyContent="start">
            <LvText h6 bold>{{ $t('選項設定') }}</LvText
            ><LvText red>*</LvText>
          </LvFlexBox>
          <WsTextButton001
            v-if="editQues.optionList && editQues.optionList.length > 1 && !isActive.sortOption"
            primary
            leadingIcon="icon-md-import-export"
            @click="$_onToggleSort('optionList')"
            >{{ $t('排序') }}</WsTextButton001
          >
        </LvFlexBox>
        <DotLoading v-if="isLoadingSelectedOption" />
        <LvSortQuesOptionList
          v-else-if="isActive.sortOption"
          :originalList="editQues.optionList"
          class="mb-20"
          @cancel="$_onToggleSort('optionList')"
          @input="$_onSubmitSort($event, 'optionList')"
        />
        <LvStateQuesOptionList
          v-else
          :list="editQues.optionList"
          class="mb-20"
          @add="$_onAdd($event, 'option')"
          @delete="$_onDelete($event, 'option')"
          @input="$_onInput($event, 'option')"
        />
      </div>
      <div v-if="editQues.quesType === 'num'">
        <LvStateRadioBtn
          :value="editQues.numConditionType"
          row
          required
          isNarrow
          rules="required"
          title="條件設定方式"
          :radioButtonItem="_numConditionTypeRadioItems"
          class="mb-20"
          @input="$_onInput($event, 'numConditionType')"
        />
        <div v-if="editQues.numConditionType && editQues.numConditionType === 'custom-num'">
          <LvFlexBox justifyContent="space-between" class="mb-4">
            <LvFlexBox justifyContent="start">
              <LvText h6 bold>{{ $t('條件式設定') }}</LvText
              ><LvText red>*</LvText>
            </LvFlexBox>
            <WsTextButton001
              v-if="
                editQues.conditionList && editQues.conditionList.length > 1 && !isActive.sortOption
              "
              primary
              leadingIcon="icon-md-import-export"
              @click="$_onToggleSort('conditionList')"
              >{{ $t('排序') }}</WsTextButton001
            >
          </LvFlexBox>
          <LvSortQuesConditionList
            v-if="isActive.sortOption"
            :originalList="editQues.conditionList"
            class="mb-20"
            @cancel="$_onToggleSort('conditionList')"
            @input="$_onSubmitSort($event, 'conditionList')"
          />
          <LvStateQuesConditionList
            v-else
            :list="editQues.conditionList"
            class="mb-20"
            @add="$_onAdd($event, 'condition')"
            @delete="$_onDelete($event, 'condition')"
            @input="$_onInput($event, 'condition')"
          />
        </div>
        <div v-if="editQues.numConditionType && editQues.numConditionType === 'control-limit'">
          <WsStateRangeInput001
            popupTitle="管制界線設定建議"
            title="Control Limit (管制界線)"
            lowerDataPlaceholder="輸入下限"
            upperDataPlaceholder="輸入上限"
            :rangeData="editQues.controlLimitData"
            :customMessages="controlLimitCustomMessages"
            :popupContent="editQues.controlLimitData.suggestVal"
            :lowerLimit="parseFloat(editQues.specLimitData.lower)"
            :upperLimit="parseFloat(editQues.specLimitData.upper)"
            class="mb-20"
            @input="$_onInput($event, 'controlLimitData')"
          />
          <WsStateRangeInput001
            popupTitle="合規界線設定建議"
            title="Spec Limit (合規界線)"
            lowerDataPlaceholder="輸入下限"
            upperDataPlaceholder="輸入上限"
            :rangeData="editQues.specLimitData"
            :customMessages="specLimitCustomMessages"
            :popupContent="editQues.specLimitData.suggestVal"
            class="mb-20"
            @input="$_onInput($event, 'specLimitData')"
          />
        </div>
        <StateInputButton
          :value="editQues.unit"
          title="單位"
          placeholder="例如：cm、kg、kPa"
          class="mb-20"
          @input="$_onInput($event, 'unit')"
        />
      </div>
      <WsInputTextareaButton001
        required
        title="合規標準"
        rules="required"
        placeholder="輸入"
        :minHeight="134"
        :value="editQues.remark"
        class="mb-20"
        @input="$_onInput($event, 'remark')"
      />
      <div class="mb-20">
        <div class="file-list mb-16">
          <LvDownloadFileBtn
            v-for="(tempAttach, tempAttachIndex) in editQues.tempAttaches"
            download
            showDeleteBtn
            :key="`temp_${tempAttachIndex}`"
            :id="tempAttach.id"
            :num="tempAttachIndex"
            :url="tempAttach.url"
            :name="tempAttach.name"
            :fileType="tempAttach.fileType"
            :hasScope="tempAttach.hasScope"
            :chipList="tempAttach.chipList"
            :showMoreBtn="tempAttach.showMoreBtn"
            :showDownloadBtn="tempAttach.showDownloadBtn"
            :isClickable="tempAttach.isClickable"
            :isImageViewable="_isImageViewable"
            :versionNumber="tempAttach.versionNumber"
            class="file"
            @remove="$_onDeleteEditQuesFile(tempAttachIndex, 'tempAttaches')"
          />
          <LvDownloadFileBtn
            v-for="(attach, attachIndex) in editQues.attaches"
            showDeleteBtn
            :key="`attach_${attachIndex}`"
            :id="attach.id"
            :num="attachIndex"
            :url="attach.url"
            :name="attach.name"
            :download="attach.hasScope"
            :fileType="attach.fileType"
            :hasScope="attach.hasScope"
            :isSystem="attach.isSystem"
            :chipList="attach.chipList"
            :versionNumber="attach.versionNumber"
            :module="uploadModule"
            :showMoreBtn="attach.showMoreBtn"
            :showDownloadBtn="attach.showDownloadBtn"
            :isClickable="attach.isClickable"
            :isImageViewable="_isImageViewable"
            class="file"
            @go-to="$_onGoToFile($event)"
            @remove="$_onDeleteEditQuesFile(attachIndex, 'attaches')"
          />
        </div>
        <LvUploadFileBtn
          multiple
          :uploadModule="uploadModule"
          :remindText="`${$t('檔案大小限制')} ≤ 30 MB`"
          :selectedFileList="editQues.attaches"
          @input="$_onInput($event, 'attaches')"
        />
      </div>
      <WsInputTextareaButton001
        title="OCAP"
        placeholder="輸入"
        :minHeight="134"
        :value="editQues.ocapRemark"
        class="mb-20"
        @input="$_onInput($event, 'ocapRemark')"
      />
      <div class="mb-20">
        <div class="file-list mb-16">
          <LvDownloadFileBtn
            v-for="(ocapAttach, ocapAttachIndex) in editQues.ocapAttaches"
            showDeleteBtn
            :key="`ocap_${ocapAttachIndex}`"
            :id="ocapAttach.id"
            :num="ocapAttachIndex"
            :url="ocapAttach.url"
            :name="ocapAttach.name"
            :download="ocapAttach.hasScope"
            :fileType="ocapAttach.fileType"
            :hasScope="ocapAttach.hasScope"
            :isSystem="ocapAttach.isSystem"
            :chipList="ocapAttach.chipList"
            :versionNumber="ocapAttach.versionNumber"
            :module="uploadModule"
            :showMoreBtn="ocapAttach.showMoreBtn"
            :showDownloadBtn="ocapAttach.showDownloadBtn"
            :isClickable="ocapAttach.isClickable"
            :isImageViewable="_isImageViewable"
            class="file"
            @go-to="$_onGoToFile($event)"
            @remove="$_onDeleteEditQuesFile(ocapAttachIndex, 'ocapAttaches')"
          />
        </div>
        <LvUploadFileBtn
          multiple
          :uploadModule="uploadModule"
          :remindText="`${$t('檔案大小限制')} ≤ 30 MB`"
          :selectedFileList="editQues.ocapAttaches"
          @input="$_onInput($event, 'ocapAttaches')"
        />
      </div>
      <LlState
        :value="editQues.lawList"
        title="關聯法規"
        type="act-pick"
        class="mb-20"
        @input="$_onInput($event, 'lawList')"
      />
      <LvPickGuideline
        :value="editQues.guidelineList"
        title="相關內規"
        class="mb-20"
        @input="$_onInput($event, 'guidelineList')"
      />
      <LvDropdownMultiCategorySelect
        :value="editQues.effects"
        outline
        label="風險"
        title="自訂風險"
        :scroll="scroll"
        :scope="_effectScope"
        :menuItems="effectList"
        :createUrl="_effectCreateUrl"
        :createFields="effect.createFields"
        :updateFields="effect.updateFields"
        :isLoadingItems="isLoadingEffectList"
        :deletePopupContentText="effect.deleteText"
        @created="$_getEffectList()"
        @delete="$_onDeleteFactoryEffect($event)"
        @update="$_onUpdateFactoryEffect($event)"
        @input="$_onInput($event, 'effects')"
        @toggle="$_onToggleEffectList($event)"
      />
    </InputListCard>
    <LlActPopup
      :lawContent="lawContent"
      :isLoading="isLoadingLawPopup"
      :popupActive="isActive.lawPopup"
      @popup-close="$_onClosePopup('lawPopup')"
    />
    <PopUp
      bottom
      title="確認要以選項組合取代目前設定的選項嗎？"
      :popUpActive="isActive.optionAlertPopup"
      @click="$_onClosePopup('optionAlertPopup')"
    >
      <LlCancelPopupContent
        cancelText="當您確認要從選項組合快速建立選項內容時，將會覆蓋掉目前已設定的全部選項！您可以在確認送出後，繼續編輯選項內容。"
      />
      <template slot="bottomBtn">
        <WsButton001 outLine widthStretch @click="$_onClosePopup('optionAlertPopup')">
          {{ $t('取消') }}
        </WsButton001>
        <WsButton001 widthStretch @click="$_onSelectOptionSet()">
          {{ $t('確定') }}
        </WsButton001>
      </template>
    </PopUp>
    <PopUp
      bottom
      title="確認要前往建立單位內常用選項組合嗎？ 目前編輯的題目將不會被儲存"
      :popUpActive="isActive.createChoicePopup"
      @click="$_onClosePopup('createChoicePopup')"
    >
      <template slot="bottomBtn">
        <WsButton001 outLine widthStretch @click="$_onClosePopup('createChoicePopup')">
          {{ $t('取消') }}
        </WsButton001>
        <WsButton001 widthStretch @click="$_onGoToCreateChoicePage()">
          {{ $t('確定') }}
        </WsButton001>
      </template>
    </PopUp>
  </div>
</template>

<script>
import S_scope from '@/service/api/v1/scope';
import S_article from '@/service/api/v1/article';
import S_commonChoice from '@/service/api/v1/commonChoice';
import S_answerSetting from '@/service/api/v1/answerSetting';
import S_factoryEffect from '@/service/api/v1/factoryEffect';
import S_answerSettingItem from '@/service/api/v1/answerSettingItem';
import S_commonChoiceGroup from '@/service/api/v1/commonChoiceGroup';
import H_file from '@/helpers/file';
import H_commonChoice from '@/helpers/commonChoice';
import H_answerSetting from '@/helpers/answerSetting';
import H_factoryEffect from '@/helpers/factoryEffect';
import H_answerSettingItem from '@/helpers/answerSettingItem';
import H_commonChoiceGroup from '@/helpers/commonChoiceGroup';
import Spare_checklist from '@/spare/checklist';
import Spare_factoryEffect from '@/spare/factoryEffect';

export default {
  props: {
    ques: {
      type: Object,
    },
    tempQues: {
      type: Object,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    scroll: {
      type: Number,
    },
    uploadModule: {
      type: String,
    },
  },
  data() {
    return {
      isActive: {
        lawPopup: false,
        optionAlertPopup: false,
        sortOption: false,
        createChoicePopup: false,
      },
      isLoadingTempOptionList: false,
      isLoadingCommonChoiceGroup: false,
      isLoadingSelectedOption: false,
      isLoadingEffectList: false,
      isLoadingLawPopup: false,
      editQues: {},
      focusRadioItems: Spare_checklist.focusRadioItems,
      controlLimitCustomMessages: Spare_checklist.controlLimitCustomMessages,
      specLimitCustomMessages: Spare_checklist.specLimitCustomMessages,
      effectList: [],
      effect: {
        createFields: Spare_factoryEffect.createFields,
        updateFields: Spare_factoryEffect.updateFields,
        deleteText: '',
      },
      isMounted: false,
      lawContent: {},
      tempOptionList: [],
      commonChoiceGroup: [],
      selectedOption: {
        type: '',
        id: '',
        name: '',
      },
    };
  },
  computed: {
    _effectScope() {
      return {
        isCreatable: S_scope.$_isAvailable(['factory-effect-create']),
        isUpdatable: S_scope.$_isAvailable(['factory-effect-update']),
        isDeletable: S_scope.$_isAvailable(['factory-effect-delete']),
      };
    },
    _effectCreateUrl() {
      return S_factoryEffect.createUrl();
    },
    _templateEffect() {
      return this.$store.state.model.effect;
    },
    _currentFactoryId() {
      return this.$store.state.app.factory.id;
    },
    _isTempQuesEmpty() {
      if (!this.tempQues) return true;
      return Object.keys(this.tempQues).length ? false : true;
    },
    _quesTypeRadioItems() {
      const buttonItems =
        this.$store.state.model.quesTypeList && this.$store.state.model.quesTypeList.length
          ? this.$store.state.model.quesTypeList.map(type => {
              return {
                id: type.value,
                textLabel: this.$t(type.name),
              };
            })
          : Spare_checklist.quesTypeRadioItems.buttonItems;
      return { buttonItems };
    },
    _numConditionTypeRadioItems() {
      const buttonItems =
        this.$store.state.model.numConditionTypeList &&
        this.$store.state.model.numConditionTypeList.length
          ? this.$store.state.model.numConditionTypeList.map(type => {
              return {
                id: type.type,
                textLabel: this.$t(type.name),
              };
            })
          : Spare_checklist.quesTypeRadioItems.buttonItems;
      return { buttonItems };
    },
    _isImageViewable() {
      return this.$store.state.app.factory.isImageViewable;
    },
  },
  async mounted() {
    this.editQues = {
      ...this.editQues,
      ...this.ques,
    };
    this.isMounted = true;
  },
  watch: {
    ques() {
      this.editQues = {
        ...this.editQues,
        ...this.ques,
      };
    },
    'editQues.quesType': {
      async handler(newVal) {
        if (newVal === 'single-choice' && this.isMounted) {
          await this.$_getTempOptionList();
          await this.$_getCommonChoiceList();
        }
      },
    },
  },
  methods: {
    async $_onToggleEffectList($event) {
      const isMenuShow = $event;
      if (isMenuShow && !this.effectList.length) {
        this.isLoadingEffectList = true;
        await this.$_getEffectList();
        this.isLoadingEffectList = false;
      }
    },
    async $_getEffectList() {
      const params = {
        order_by: 'sequence',
        order_way: 'asc',
        get_all: 1,
      };
      const res = await S_factoryEffect.index(params);
      this.effectList = H_factoryEffect.setDropdownCustomItems(this._templateEffect, res);
    },
    async $_onDeleteFactoryEffect($event) {
      const { value: id } = $event;
      await S_factoryEffect.delete(id);
      await this.$_getEffectList();
    },
    async $_onUpdateFactoryEffect($event) {
      const { value: id, name } = $event;
      const data = {
        name,
      };
      await S_factoryEffect.update(id, data);
      await this.$_getEffectList();
    },
    $_onDeleteEditQuesFile(index, type) {
      this.editQues[type].splice(index, 1);
      this.$emit('input', this.editQues);
    },
    $_onInput($event, key) {
      if (!this.isMounted) return;
      if (key === 'attaches' || key === 'ocapAttaches')
        this.editQues[key] = [...this.editQues[key], ...$event];
      else if (key === 'option') {
        const { index, value, subOptionIndex } = $event;
        if (subOptionIndex === undefined) {
          this.$set(this.editQues.optionList, index, value);
        } else {
          this.$set(this.editQues.optionList[index].subOptionList, subOptionIndex, value);
        }
      } else if (key === 'condition') {
        const { index, value } = $event;
        this.$set(this.editQues.conditionList, index, value);
      } else this.editQues[key] = $event;
      this.$emit('input', this.editQues);
    },
    $_onFillFromTempQues() {
      this.$emit('fill-from-temp-ques');
    },
    async $_onClickLaw($event) {
      this.lawContent = {};
      const { type, id, versionId } = $event;
      if (type === 'act') {
        const url = this.$router.resolve({
          path: `/factory/${this._currentFactoryId}/act-content-main/${id}`,
        });
        window.open(url.href, '_blank');
      } else {
        this.$_onOpenPopup('lawPopup');
        this.isLoadingLawPopup = true;
        const article = await S_article.getLawContent(this._currentFactoryId, versionId);
        this.lawContent = S_article.getLawData(article);
        this.isLoadingLawPopup = false;
      }
    },
    $_onOpenPopup(type) {
      this.isActive[type] = true;
    },
    $_onClosePopup(type) {
      if (!this.isActive[type]) return;
      this.isActive[type] = false;
    },
    $_onGoToFile($event) {
      H_file.goToFile($event);
    },
    async $_onClickOptionSet($event, type) {
      this.selectedOption = {
        type,
        id: $event,
      };
      if (this.ques.optionList && this.ques.optionList.length)
        this.$_onOpenPopup('optionAlertPopup');
      else await this.$_onSelectOptionSet();
    },
    async $_onSelectOptionSet() {
      this.$_onClosePopup('optionAlertPopup');
      this.isLoadingSelectedOption = true;
      const { id, type } = this.selectedOption;
      const [key, clearKey] =
        type === 'tempOption'
          ? ['answerSetting', 'commonChoiceGroup']
          : ['commonChoiceGroup', 'answerSetting'];
      this.$_onInput(id, key);
      this.$_onInput('', clearKey);
      let optionList = [];
      if (type === 'tempOption') {
        const res = await S_answerSettingItem.index(id, { get_all: 1, is_parent: 1 });
        optionList = H_answerSettingItem.setOptionList(res);
      } else {
        const res = await S_commonChoice.index(id, { get_all: 1, is_parent: 1 });
        optionList = H_commonChoice.setOptionList(res);
      }
      this.$_onInput(optionList, 'optionList');
      this.isLoadingSelectedOption = false;
    },
    $_onAdd($event, type) {
      if (type === 'option') {
        const optionIndex = $event;
        const option = {
          title: '',
          score: null,
          requiredRemark: false,
          risk: null,
        };
        if (optionIndex === undefined) {
          this.editQues.optionList.push({
            ...option,
            hasSubOption: false,
            subOptionList: [],
          });
        } else {
          this.editQues.optionList[optionIndex].subOptionList.push(option);
        }
        this.$emit('input', this.editQues);
      } else if (type === 'condition') {
        this.editQues.conditionList.push({
          operator: 'gt',
          lowVal: null,
          highVal: null,
          risk: null,
        });
      }
    },
    $_onDelete($event, type) {
      if (type === 'option') {
        const { optionIndex, subOptionIndex } = $event;
        if (subOptionIndex === undefined) this.editQues.optionList.splice(optionIndex, 1);
        else this.editQues.optionList[optionIndex].subOptionList.splice(subOptionIndex, 1);
      } else if (type === 'condition') {
        const index = $event;
        this.editQues.conditionList.splice(index, 1);
      }
      this.$emit('input', this.editQues);
    },
    $_onToggleSort(type) {
      if (type === 'optionList' || type === 'conditionList')
        this.isActive.sortOption = !this.isActive.sortOption;
    },
    $_onSubmitSort($event, type) {
      this.editQues[type] = $event;
      this.$_onToggleSort(type);
    },
    async $_getTempOptionList() {
      this.isLoadingTempOptionList = true;
      const res = await S_answerSetting.getTempOptionList();
      this.tempOptionList = H_answerSetting.setTempOptionBtnList(res);
      this.isLoadingTempOptionList = false;
    },
    async $_getCommonChoiceList() {
      this.isLoadingCommonChoiceGroup = true;
      const res = await S_commonChoiceGroup.index({
        order_way: 'asc',
        order_by: 'created_at',
      });
      this.commonChoiceGroup = H_commonChoiceGroup.setCommonChoiceGroupBtnList(res);
      this.isLoadingCommonChoiceGroup = false;
    },
    $_onGoToCreateChoicePage() {
      this.$router.push(`/factory/${this._currentFactoryId}/checklist-common-choice-group-create`);
    },
  },
};
</script>
<style lang="scss" scoped>
.lv-question-state__btn-title-wrap {
  @include flex;
  width: 100%;
  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
}
</style>
